import React from 'react';
import { orderDetailType } from '../../../constants/types/mypage-type';
import OrderDetailLayout from './OrderDetailLayout';
import OrderItemList from '../../purchase/OrderItemList';

const OrderIteminfo = ({ orderDetail }: { orderDetail: orderDetailType }) => {
  return (
    <OrderDetailLayout title="상품 정보">
      <OrderItemList orderItems={orderDetail.template.order_items} />
    </OrderDetailLayout>
  );
};

export default OrderIteminfo;
